/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.5 13.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5S0 11.1716 0 12s.6716 1.5 1.5 1.5Zm10.5 0c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5ZM24 12c0 .8284-.6716 1.5-1.5 1.5S21 12.8284 21 12s.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Z"
    clipRule="evenodd"
  />,
  'ShowMore'
);
